import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { PerfilService } from "../perfil.service";
import { LoginService } from "src/app/authentication/login/login.service";
import { NgxSpinnerService } from "ngx-spinner";
import { SnackBarService } from "src/app/services/snack-bar.service";
import { MatOverlayService } from "src/app/services/mat-overlay.service";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { ChristmasService } from "src/app/services/christmas.service";

@Component({
  selector: "app-modulos",
  templateUrl: "./modulos.component.html",
  styleUrls: ["./modulos.component.css"],
})
export class ModulosComponent implements OnInit, OnDestroy {
  private URL: string = "/main/";
  modulos: [] = [];
  usuario: any;
  nomeServidor: string;
  lotacaoUsuario: string;
  isChristmasMode: boolean = false;
  private routerSubscription: Subscription;
  private isReloading: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private perfilService: PerfilService,
    private loginService: LoginService,
    private spinner: NgxSpinnerService,
    private snackBarService: SnackBarService,
    private overlayService: MatOverlayService,
    private christmasService: ChristmasService
  ) {}

  async ngOnInit() {
    this.isChristmasMode = this.christmasService.isChristmasMode();
    const cacheServidor = JSON.parse(localStorage.getItem("user"));
    this.nomeServidor = cacheServidor ? cacheServidor.nome : "";
    this.lotacaoUsuario = cacheServidor ? cacheServidor.lotacao : "";

    await this.recarregarModulos();

    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (event.url === '/modulos' && !this.isReloading) {
          setTimeout(() => {
            this.recarregarModulos();
          }, 100);
        }
      });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private async recarregarModulos() {
    if (this.isReloading) {
      return;
    }

    try {
      this.isReloading = true;
      this.spinner.show();
      const resultado: any = await this.perfilService.recarregarModulosUsuario();

      if (resultado && resultado.modulos) {
        const modulosFormatados = resultado.modulos.map(modulo => ({
          "id_modulo": modulo.id_modulo,
          "desc_modulo": modulo.desc_modulo,
          "sigla": modulo.sigla
        }));

        localStorage.setItem('modulos', JSON.stringify(modulosFormatados));
        this.modulos = modulosFormatados;

        console.log('Módulos recarregados com sucesso:', this.modulos.length, 'módulos encontrados');
      } else {
        throw new Error('Resposta inválida da API');
      }
    } catch (error) {
      console.error('Erro ao recarregar módulos:', error);

      const cacheModulos = JSON.parse(localStorage.getItem("modulos"));
      if (cacheModulos) {
        this.modulos = cacheModulos;
        console.log('Carregados módulos do cache:', this.modulos.length, 'módulos');
      } else {
        this.modulos = [];
      }

      if (error.status === 401) {
        this.snackBarService.showSnackBarError('Sessão expirada. Faça login novamente.');
        this.logout();
      } else {
        this.snackBarService.showSnackBarError('Erro ao carregar módulos atualizados. Usando dados em cache.');
      }
    } finally {
      this.isReloading = false;
      this.spinner.hide();
    }
  }

  async getPerfilUsuarioModulo(modulo) {
    let idModulo = modulo.id_modulo;
    let nomeModulo = modulo.sigla.toLowerCase();
    this.spinner.show();
    await this.perfilService
      .getPerfilUsuarioPorModulo(idModulo)
      .then(
        (ret: any[]) => {
          const perfilAtivo = ret.find((x) => x.perfilModulo && x.perfilModulo.ativo);

          if (!perfilAtivo || !perfilAtivo.perfilModulo) {
            console.error('Perfil ativo não encontrado para o módulo:', modulo.sigla);
            this.snackBarService.showSnackBarError('Perfil não encontrado para este módulo. Contate o administrador.');
            return;
          }

          this.setPerfilModulo(perfilAtivo);
          this.setTokenPerfil(perfilAtivo);

          this.router.navigateByUrl(`${this.URL}${nomeModulo}`);
        },
        (error) => {
          console.error('Erro ao buscar perfil do módulo:', error);
          this.snackBarService.showSnackBarError('Erro ao acessar o módulo. Tente novamente.');
        }
      )
      .finally(() => this.spinner.hide());
  }

  setPerfilModulo(data) {
    if (!data || !data.perfilModulo) {
      console.error('Tentativa de salvar perfil inválido:', data);
      return;
    }
    localStorage.setItem("perfil", JSON.stringify(data.perfilModulo));
  }

  setTokenPerfil(data) {
    if (!data || !data.token) {
      console.warn('Token do perfil não disponível');
      return;
    }
    localStorage.setItem("tokenPerfil", JSON.stringify(data.token));
  }

  getModuloLabel(sigla) {
    switch (sigla) {
      case "TAC":
        return "TAC";
      case "PAD":
        return "PAD";
      case "SIND":
        return "Sindicância";
      case "TCA":
        return "TCA";
      case "API":
        return "API";
      case "MED":
        return "Mediação";
      case "TAC2":
        return "TAC2";
      case "SGU":
        return "SGU";
      case "PPI":
        return "PPI";
      default:
        break;
    }
  }

  getModuloDescription(sigla) {
    switch (sigla) {
      case "TAC":
        return "Termo de Ajustamento de Conduta";
      case "PAD":
        return "Processo Administrativo Disciplinar";
      case "SIND":
        return "Processo de Sindicância";
      case "TCA":
        return "Tomada de Contas Administrativa";
      case "API":
        return "Sistema de Interface API";
      case "MED":
        return "Processo de Mediação";
      case "TAC2":
        return "TAC Segunda Geração";
      case "SGU":
        return "Sistema de Gerenciamento de Usuários";
      case "PPI":
        return "Processo Preliminar Investigatório";
      default:
        return "Módulo do sistema";
    }
  }

  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/');
  }
  iconControlIcon(sigla) {
    switch (sigla) {
      case "TAC":
        return "handshake";
      case "PAD":
        return "gavel";
      case "SIND":
        return "search";
      case "TCA":
        return "description";
      case "API":
        return "description";
      case "MED":
        return "description";
      case "TAC2":
        return "description";
      case "SGU":
        return "people";
      case "PPI":
        return "folder_open";
      default:
        break;
    }
  }
  iconControl(sigla) {
    return `../../../../../assets/img/${sigla.toLowerCase()}.png`;
  }

  getModuleBackgroundImage(sigla) {
    switch (sigla) {
      case "TAC":
        return "../../../assets/img/sispac-new/tac.png";
      case "PAD":
        return "../../../assets/img/sispac-new/pad.png";
      case "SIND":
        return "../../../assets/img/sispac-new/sindicancia.png";
      case "TCA":
        return "../../../assets/img/sispac-new/TCA.png";
      case "API":
        return "../../../assets/img/sispac-new/api.png";
      case "MED":
        return "../../../assets/img/sispac-new/mediacao.png";
      case "TAC2":
        return "../../../assets/img/sispac-new/tac2.png";
      case "SGU":
        return "../../../assets/img/sispac-new/sgu.jpg";
      case "PPI":
        return "../../../assets/img/sispac-new/ppi.jpg";
      default:
        return "../../../assets/img/sispac-new/api.png"; // fallback
    }
  }

  toggleProfileOverlay(event: MouseEvent) {
    if (this.overlayService.isOpen()) {
      this.closeProfileOverlay();
    } else {
      this.openProfileOverlay(event);
    }
  }

  openProfileOverlay(event: MouseEvent) {
    import('./modulos-profile/modulos-profile.component').then(m => {
      this.overlayService.open(m.ModulosProfileComponent, event.currentTarget);
    });
  }

  closeProfileOverlay() {
    this.overlayService.close();
  }
}
